import { render, staticRenderFns } from "./QlcMacros.vue?vue&type=template&id=35241a4a&scoped=true"
import script from "./QlcMacros.vue?vue&type=script&lang=js"
export * from "./QlcMacros.vue?vue&type=script&lang=js"
import style0 from "./QlcMacros.vue?vue&type=style&index=0&id=35241a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35241a4a",
  null
  
)

export default component.exports